<span class="button" [ngClass]="{ 'with-icon': iconName }">
    @if (isLoading) {
        <div class="custom-spinner"></div>
    }
    <span class="content">
        @if (iconName) {
            <div class="icon">
                <i-feather [name]="iconName" [class]="iconName"></i-feather>
            </div>
        }
        <span class="center">{{ label | translate }}</span>
    </span>
</span>
